import { action, computed, observable } from 'mobx';
import { BaseListState } from '../../../../commonv3/states/LocationListState';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { LocationId } from '../../../../commonv3/types/locations';
import { HomeLocationApis } from '../../../apis/homeLocations';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { HomeLocationState } from '../../../../commonv3/states/HomeLocationState';
import { V3Routes } from '../../../routes';

export class HomeLocationUpdatePageState {
    @observable baseList = new BaseListState();
    @observable homeLocation: HomeLocationState = null;
    @observable selectedLocationId = -1;
    @observable submitState = new SubmitState();

    constructor(homeLocation: HomeLocationState) {
        this.homeLocation = homeLocation;
    }

    @action.bound
    async init() {
        const { homeLocation } = GlobalStatesV3.currentUser;
        await Promise.all([await this.baseList.init(), await homeLocation.reload()]);
    }

    @action.bound
    selectLocation(locationId: LocationId) {
        this.selectedLocationId = locationId;
    }

    @action.bound
    async submit() {
        await this.submitState.operate(async () => {
            await HomeLocationApis.update(this.selectedLocationId);
            await this.homeLocation.reload();
            GlobalStatesV3.routing.push(V3Routes.homeLocation());
        });
    }

    @computed
    get submitting() {
        return this.submitState.submitting;
    }

    @computed
    get loading() {
        return GlobalStatesV3.currentUser.homeLocation.loading || this.baseList.loading;
    }
}
